import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hobby" }


const __default__ = { name: 'Hobby' };

import {reactive, ref, onBeforeMount, onMounted} from 'vue';



export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose }) {

onBeforeMount(() => {
  // console.log('2.组件挂载页面之前执行----onBeforeMount');
});
onMounted(() => {
  // console.log('3.-组件挂载到页面之后执行-------onMounted');
});
expose({
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, "Hobby"))
}
}

})